export const set_user_token = 'set_user_token'
export const remove_token_from_local = 'remove_token_from_local'
export const set_current_user_data = 'set_current_user_data'
